import { graphql, useStaticQuery } from 'gatsby';

export default function useOptimizedImage(fileName) {
  const data = useStaticQuery(graphql`
    query optimizedImages {
      allFile(
        filter: {
          extension: { regex: "/(jpeg|jpg|gif|png)/" }
          absolutePath: { regex: "/.*/assets/resources/optimized-images/.*/" }
        }
      ) {
        edges {
          node {
            absolutePath
            childImageSharp {
              fluid(
                quality: 100
                maxWidth: 2000
                pngCompressionSpeed: 8
                srcSetBreakpoints: [320, 600, 1200]
              ) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
        }
      }
    }
  `);
  const selectedImg = data.allFile.edges.find(({ node }) =>
    node.absolutePath.endsWith(fileName)
  );
  try {
    // eslint-disable-next-line no-unused-vars
    const _ = selectedImg.node.childImageSharp.fixed;
    return selectedImg.node.childImageSharp;
  } catch {
    throw new Error(
      `File with path that ends with ${fileName} was not found in assets/resources/optimized-images/. Check your static files! :)`
    );
  }
}
